module.exports = __webpack_public_path__ + "static/media/c.f11eb38b.jpg";